import React, { useCallback, useId, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

// Sol raydaki bir ana maddenin açılır alt menüsü (Merit ve Betrun).
// Alt maddeler sayfanın kendi sekmeleridir; menü açılır/kapanır ve
// varsayılan açıktır, oyuncunun seçimi kendi tarayıcısında kalır (Vega'nın
// görünüm anahtarıyla aynı yaklaşım). Sınıf adları şemanın önekini taşır
// (`<önek>-rail-sub` …): görünüm her şemanın kendi CSS'indedir. Dar ikon
// rayında alt menü CSS ile gizlenir.
const readOpen = (storageKey) => {
  try {
    return window.localStorage.getItem(storageKey) !== '0';
  } catch {
    return true;
  }
};

const RailSubmenu = ({
  prefix, children, onNavigate, items, currentId, pathFor, storageKey, groupLabel,
  showLabel, hideLabel,
}) => {
  const listId = useId();
  const [open, setOpen] = useState(() => readOpen(storageKey));
  const toggle = useCallback(() => {
    setOpen((value) => {
      const next = !value;
      try { window.localStorage.setItem(storageKey, next ? '1' : '0'); } catch { /* tercih yalnızca kolaylıktır */ }
      return next;
    });
  }, [storageKey]);

  return (
    <>
      <div className={`${prefix}-rail-parent`}>
        {children}
        <button
          type="button"
          className={`${prefix}-rail-caret ${open ? 'is-open' : ''}`}
          onClick={toggle}
          aria-expanded={open}
          aria-controls={listId}
          aria-label={open ? hideLabel : showLabel}
        >
          <ChevronDown size={16} aria-hidden="true" />
        </button>
      </div>
      {open && (
        <div id={listId} className={`${prefix}-rail-sub`} role="group" aria-label={groupLabel}>
          {items.map((t) => (
            // Link, NavLink değil: NavLink adresin sorgusunu saymaz ve
            // sayfadayken bütün alt maddeleri etkin boyardı.
            <Link
              key={t.id}
              to={pathFor(t.id)}
              onClick={onNavigate}
              className={`${prefix}-rail-btn ${prefix}-rail-sub-btn ${currentId === t.id ? 'active' : ''}`}
              aria-current={currentId === t.id ? 'page' : undefined}
              title={t.name}
            >
              <t.icon size={16} aria-hidden="true" />
              <span className={`${prefix}-rail-label`}>{t.name}</span>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default RailSubmenu;
